import angular from 'angular';

import portalConstantsModule from 'portal/common/constants';

import shopConstants from './constants';

export default angular.module('fp:customerportal:shop:common:constants', [
    portalConstantsModule.name
])
    .constant('templateData', window._liquid)
    .config(/*@ngInject*/ ($provide, constants) => {
        let newConstants = angular.extend(constants, shopConstants);
        $provide.constant('constants', newConstants);
    });